/**
 * Pagination shim — delegates to CollectionController when present.
 */
(function () {
  function init() {
    const controller =
      window.CollectionController?.instance || window.CollectionController?.init();
    controller?.bindPagination();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('collection-grid-updated', init);
})();
